<template>
  <span>
    <span v-if="event.eventtime_override">
      {{ event.eventtime_override }}
    </span>
    <span v-else-if="event.eventtime" class="capitalize">
      {{ formatDate(getEventtime(event), { locale: $i18n.locale, showTime }) }}
    </span>
    <span v-else-if="event.dateRange" class="flex items-center capitalize">
      {{ formatDate(event.dateRange[0], { locale: $i18n.locale, showTime }) }}
      <ArrowRightIcon class="mx-2 w-3 h-3" />
      {{ formatDate(event.dateRange[1], { locale: $i18n.locale, showTime }) }}
    </span>
  </span>
</template>

<script setup lang="ts">
  import type { EventItem } from '@/types';
  import { getEventtime } from '@/utils/eventItemUtil';
  import { formatDate } from '@/utils/formatDate';

  import ArrowRightIcon from '../icons/ArrowRightIcon.vue';

  defineProps<{
    event: EventItem;
    showTime?: boolean;
  }>();
</script>
